/* eslint import/no-unresolved: 0 */
import PropTypes from 'prop-types';
import { useIntl } from '@edx/frontend-platform/i18n';

import { setLocalStorage } from '@src/data/localStorage';

const PastExpirationDateBanner = ({
  courseId, accessExpirationDate, timezoneFormatArgs, setupgradeNotificationCurrentState,
}) => {
  const intl = useIntl();
  if (setupgradeNotificationCurrentState) {
    setupgradeNotificationCurrentState('PastExpirationDate');
    setLocalStorage(`upgradeNotificationCurrentState.${courseId}`, 'PastExpirationDate');
  }
  return (
    <div className="upsell-warning">
      {intl.formatMessage(
        {
          id: 'advertisements.upgradeNotification.pastExpiration.banner',
          defaultMessage: 'Upgrade deadline passed on {date}',
          description: 'Message notifying user when upgrade deadline passed',
        },
        {
          date: intl.formatDate(accessExpirationDate, {
            key: 'accessExpireDate',
            day: 'numeric',
            month: 'long',
            ...timezoneFormatArgs,
          }),
        },
      )}
    </div>
  );
};

PastExpirationDateBanner.propTypes = {
  courseId: PropTypes.string.isRequired,
  accessExpirationDate: PropTypes.PropTypes.instanceOf(Date).isRequired,
  timezoneFormatArgs: PropTypes.shape({
    timeZone: PropTypes.string,
  }),
  setupgradeNotificationCurrentState: PropTypes.func,
};

PastExpirationDateBanner.defaultProps = {
  timezoneFormatArgs: {},
  setupgradeNotificationCurrentState: null,
};

export default PastExpirationDateBanner;
